import * as Models from "../Models";
import * as Common from "../Common/modules";

export interface IScriptsApiClient {
  getPaymentAuthScripts: (request: Models.Scripts.ScriptsRequest.ScriptsRequest) => ng.IPromise<any>;
}

export class ScriptsApiClient implements IScriptsApiClient {
  public prefix: string;

  public static $inject = ['igs.apiClientService'];

  constructor(private igsApiClientService: Common.ApiClientService.Igs.Common.IApiClientService) {
  }

  public getPaymentAuthScripts = (scriptsRequest: Models.Scripts.ScriptsRequest.ScriptsRequest): ng.IPromise<any> => {
    return this.igsApiClientService.post("Scripts/GetPaymentAuthorizationScripts", scriptsRequest);
  }
}